const mutations = {
  getTncCategory: (state, tnc_id) => {
    state.tnc_id = tnc_id;
  },
};

export default mutations;
